/**
 * 存储localStorage
 */
export const setLocalStorage = (name: string, content: any) => {
  if (!name) return;
  if (typeof content !== "string") {
    content = JSON.stringify(content) || "";
  }
  window.localStorage.setItem(name, content);
};

/**
   * 获取localStorage
   */
export const getLocalStorage = (name: string) => {
  if (!name) return;
  return window.localStorage.getItem(name);
};

/**
   * 删除localStorage
   */
export const removeLocalStorage = (name: string) => {
  if (!name) return;
  window.localStorage.removeItem(name);
};
/**
 * 匹配url
 */

export const verifyUrl = (url: string) => {
  let reg = /^(?:(http|https|ftp):\/\/)?((?:[\w-]+\.)+[a-z0-9]+)((?:\/[^/?#]*)+)?(\?[^#]+)?(#.+)?$/i;
  return reg.exec(url);
};

export const clearAllCookie = () => {
  // eslint-disable-next-line no-useless-escape
  let keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (let i = keys.length; i--;) { document.cookie = keys[i] + "=0;expires=" + new Date(0).toUTCString(); }
  }
};
